import { render } from "./Pill.vue?vue&type=template&id=4bf637fb&scoped=true&ts=true"
import script from "./Pill.vue?vue&type=script&lang=ts"
export * from "./Pill.vue?vue&type=script&lang=ts"

import "./Pill.vue?vue&type=style&index=0&id=4bf637fb&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf637fb"]])

export default __exports__